/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicableCredit } from './ApplicableCredit';
import {
    ApplicableCreditFromJSON,
    ApplicableCreditFromJSONTyped,
    ApplicableCreditToJSON,
    ApplicableCreditToJSONTyped,
} from './ApplicableCredit';

/**
 * 
 * @export
 * @interface CreditAwareSolution
 */
export interface CreditAwareSolution {
    /**
     * Primary carrier IATA code
     * @type {string}
     * @memberof CreditAwareSolution
     */
    carrier?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditAwareSolution
     */
    flightNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditAwareSolution
     */
    origin?: string;
    /**
     * 
     * @type {string}
     * @memberof CreditAwareSolution
     */
    destination?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreditAwareSolution
     */
    departureTime?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreditAwareSolution
     */
    arrivalTime?: Date | null;
    /**
     * Original fare amount in USD
     * @type {number}
     * @memberof CreditAwareSolution
     */
    fareAmount?: number;
    /**
     * Price after best credit applied
     * @type {number}
     * @memberof CreditAwareSolution
     */
    effectivePrice?: number;
    /**
     * Whether a credit fully covers this fare
     * @type {boolean}
     * @memberof CreditAwareSolution
     */
    creditCoversFully?: boolean;
    /**
     * Original price string (e.g. USD168.40)
     * @type {string}
     * @memberof CreditAwareSolution
     */
    totalPrice?: string;
    /**
     * 
     * @type {Array<ApplicableCredit>}
     * @memberof CreditAwareSolution
     */
    applicableCredits?: Array<ApplicableCredit>;
}

/**
 * Check if a given object implements the CreditAwareSolution interface.
 */
export function instanceOfCreditAwareSolution(value: object): value is CreditAwareSolution {
    return true;
}

export function CreditAwareSolutionFromJSON(json: any): CreditAwareSolution {
    return CreditAwareSolutionFromJSONTyped(json, false);
}

export function CreditAwareSolutionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreditAwareSolution {
    if (json == null) {
        return json;
    }
    return {
        
        'carrier': json['carrier'] == null ? undefined : json['carrier'],
        'flightNumber': json['flight_number'] == null ? undefined : json['flight_number'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'destination': json['destination'] == null ? undefined : json['destination'],
        'departureTime': json['departure_time'] == null ? undefined : (new Date(json['departure_time'])),
        'arrivalTime': json['arrival_time'] == null ? undefined : (new Date(json['arrival_time'])),
        'fareAmount': json['fare_amount'] == null ? undefined : json['fare_amount'],
        'effectivePrice': json['effective_price'] == null ? undefined : json['effective_price'],
        'creditCoversFully': json['credit_covers_fully'] == null ? undefined : json['credit_covers_fully'],
        'totalPrice': json['total_price'] == null ? undefined : json['total_price'],
        'applicableCredits': json['applicable_credits'] == null ? undefined : ((json['applicable_credits'] as Array<any>).map(ApplicableCreditFromJSON)),
    };
}

export function CreditAwareSolutionToJSON(json: any): CreditAwareSolution {
    return CreditAwareSolutionToJSONTyped(json, false);
}

export function CreditAwareSolutionToJSONTyped(value?: CreditAwareSolution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carrier': value['carrier'],
        'flight_number': value['flightNumber'],
        'origin': value['origin'],
        'destination': value['destination'],
        'departure_time': value['departureTime'] == null ? value['departureTime'] : value['departureTime'].toISOString(),
        'arrival_time': value['arrivalTime'] == null ? value['arrivalTime'] : value['arrivalTime'].toISOString(),
        'fare_amount': value['fareAmount'],
        'effective_price': value['effectivePrice'],
        'credit_covers_fully': value['creditCoversFully'],
        'total_price': value['totalPrice'],
        'applicable_credits': value['applicableCredits'] == null ? undefined : ((value['applicableCredits'] as Array<any>).map(ApplicableCreditToJSON)),
    };
}

